import * as classNames from 'classnames';
import * as React from 'react';

import {
    button as cssButton,
    label as cssLabel,
} from './collab-sidebar.module.sass';

import {
    tabs as cssTabs,
    tab as cssTab,
} from './mobile-tabs.module.sass';

export enum MobileTabName {
    Content,
    Video,
}

export const MobileTabs: React.StatelessComponent<any> = (
    {shouldShowContent, toggleContent}
) => (
    <div className={cssTabs}>
        <button
            className={classNames(cssButton, cssTab)}
            disabled={shouldShowContent}
            onClick={toggleContent}
            type='button'
        >
            <i className='fa fa-file-text' />
            <div className={cssLabel}>Content</div>
        </button>
        <button
            className={classNames(cssButton, cssTab)}
            disabled={!shouldShowContent}
            onClick={toggleContent}
            type='button'
        >
            <i className='fa fa-video-camera' />
            <div className={cssLabel}>Video</div>
        </button>
    </div>
);
